/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseBoolean,
  ResponseFeedbackItemResVo,
  ResponsePageDataFeedbackItemResVo,
  SubmitReqVo,
} from '../models/index';
import {
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseFeedbackItemResVoFromJSON,
    ResponseFeedbackItemResVoToJSON,
    ResponsePageDataFeedbackItemResVoFromJSON,
    ResponsePageDataFeedbackItemResVoToJSON,
    SubmitReqVoFromJSON,
    SubmitReqVoToJSON,
} from '../models/index';

export interface FeedbackMyListGetRequest {
    currentPage?: number;
    pageSize?: number;
    type?: number;
    status?: number;
}

export interface FeedbackMyListIdDeleteRequest {
    id: number;
}

export interface FeedbackMyListIdGetRequest {
    id: number;
}

export interface FeedbackSubmitPostRequest {
    submitReqVo?: SubmitReqVo;
}

/**
 * 
 */
export class FeedbackControllerApi extends runtime.BaseAPI {

    /**
     * 分页查询当前登录会员的提交记录。 错误报告&改善提议·查询我的提交记录
     * 错误报告&改善提议·查询我的提交记录
     */
    async feedbackMyListGetRaw(requestParameters: FeedbackMyListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataFeedbackItemResVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feedback/my-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataFeedbackItemResVoFromJSON(jsonValue));
    }

    /**
     * 分页查询当前登录会员的提交记录。 错误报告&改善提议·查询我的提交记录
     * 错误报告&改善提议·查询我的提交记录
     */
    async feedbackMyListGet(requestParameters: FeedbackMyListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataFeedbackItemResVo> {
        const response = await this.feedbackMyListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 删除当前登录会员自己的反馈。 错误报告&改善提议·删除我的反馈
     * 错误报告&改善提议·删除我的反馈
     */
    async feedbackMyListIdDeleteRaw(requestParameters: FeedbackMyListIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling feedbackMyListIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feedback/my-list/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 删除当前登录会员自己的反馈。 错误报告&改善提议·删除我的反馈
     * 错误报告&改善提议·删除我的反馈
     */
    async feedbackMyListIdDelete(requestParameters: FeedbackMyListIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.feedbackMyListIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 查询当前登录会员的反馈详情，含附件和管理端回复历史。 错误报告&改善提议·查询我的反馈详情
     * 错误报告&改善提议·查询我的反馈详情
     */
    async feedbackMyListIdGetRaw(requestParameters: FeedbackMyListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseFeedbackItemResVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling feedbackMyListIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feedback/my-list/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseFeedbackItemResVoFromJSON(jsonValue));
    }

    /**
     * 查询当前登录会员的反馈详情，含附件和管理端回复历史。 错误报告&改善提议·查询我的反馈详情
     * 错误报告&改善提议·查询我的反馈详情
     */
    async feedbackMyListIdGet(requestParameters: FeedbackMyListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseFeedbackItemResVo> {
        const response = await this.feedbackMyListIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 提交错误报告或改善提议。 提交反馈
     * 提交反馈
     */
    async feedbackSubmitPostRaw(requestParameters: FeedbackSubmitPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseFeedbackItemResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feedback/submit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitReqVoToJSON(requestParameters['submitReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseFeedbackItemResVoFromJSON(jsonValue));
    }

    /**
     * 提交错误报告或改善提议。 提交反馈
     * 提交反馈
     */
    async feedbackSubmitPost(requestParameters: FeedbackSubmitPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseFeedbackItemResVo> {
        const response = await this.feedbackSubmitPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
